<template>
    <div class="settings-page">
        <h2>Social</h2>
        <div class="integration-row">
            <div>
                <img src="../../../assets/img/facebook.svg">
                <span>Facebook</span>
                <div class="with-tooltip ml-auto">
                    <img class="info-img" src="../../../assets/img/info.svg">
                    <span class="tooltiptext">Add a registration link to your Facebook page</span>
                </div>
            </div>
            <div>
                <button class="secondary-btn btn-center"
                        @click="postToFacebook"
                        type="button">Post
                </button>
            </div>
        </div>
        <div class="integration-row">
            <div>
                <img src="../../../assets/img/twitter.svg">
                <span>Twitter</span>
                <div class="ml-auto with-tooltip">
                    <img class="info-img" src="../../../assets/img/info.svg">
                    <span class="tooltiptext">Add a registration link to your Twitter page</span>
                </div>
            </div>
            <div>
                <a :href="twitterPostUrl"
                   data-show-count="false">
                    <button class="secondary-btn btn-center"
                            type="button">Post
                    </button>
                </a>
            </div>
        </div>
        <h2>Website</h2>
        <div class="integration-row website-integration">
            <div>
                <span>Registration button</span>
                <div class="ml-auto with-tooltip">
                    <img class="info-img" src="../../../assets/img/info.svg">
                    <span class="tooltiptext">Add a Registration button to  your website by simply copying and pasting the code</span>
                </div>
            </div>
            <div>
                <button class="secondary-btn btn-center"
                        type="button"
                        @click="copyRegistrationButtonWidget">
                    Copy code
                </button>
            </div>
        </div>
        <div class="integration-row website-integration">
            <div>
                <span>Class Calendar</span>
                <div class="ml-auto with-tooltip class-calendar">
                    <img class="info-img" src="../../../assets/img/info.svg">
                    <span class="tooltiptext">Add a Class Calendar to your website by simply copying and pasting the code</span>
                </div>
            </div>
            <div>
                <button class="secondary-btn btn-center"
                        type="button"
                        @click="copyCalendarWidget('classes')">
                    Copy code
                </button>
            </div>
        </div>
        <div class="integration-row website-integration">
            <div>
                <span>Camp Calendar</span>
                <div class="ml-auto with-tooltip camp-calendar">
                    <img class="info-img" src="../../../assets/img/info.svg">
                    <span class="tooltiptext">Add a Camp Calendar to your website by simply copying and pasting the code</span>
                </div>
            </div>
            <div>
                <button class="secondary-btn btn-center"
                        type="button"
                        @click="copyCalendarWidget('camps')">
                    Copy code
                </button>
            </div>
        </div>
        <div class="integration-row website-integration">
            <div>
                <span>After Care Calendar</span>
                <div class="ml-auto with-tooltip">
                    <img class="info-img" src="../../../assets/img/info.svg">
                    <span class="tooltiptext">Add a After Care Sessions Calendar to your website by simply copying and pasting the code</span>
                </div>
            </div>
            <div>
                <button class="secondary-btn btn-center"
                        type="button"
                        @click="copyCalendarWidget('aftercare')">
                    Copy code
                </button>
            </div>
        </div>
        <div class="integration-row website-integration">
            <div>
                <span>Class list</span>
                <div class="ml-auto with-tooltip class-list">
                    <img class="info-img" src="../../../assets/img/info.svg">
                    <span class="tooltiptext">Add a Class list to  your website by simply copying and pasting the code</span>
                </div>
            </div>
            <div>
                <button class="secondary-btn btn-center"
                        type="button"
                        @click="copyActivityListWidget('classes')">
                    Copy code
                </button>
            </div>
        </div>
        <div class="integration-row website-integration">
            <div>
                <span>Camp list</span>
                <div class="ml-auto with-tooltip camp-list">
                    <img class="info-img" src="../../../assets/img/info.svg">
                    <span class="tooltiptext">Add a Camp list to  your website by simply copying and pasting the code</span>
                </div>
            </div>
            <div>
                <button class="secondary-btn btn-center"
                        type="button"
                        @click="copyActivityListWidget('camps')">
                    Copy code
                </button>
            </div>
        </div>

        <div class="integration-row website-integration">
            <div>
                <span>After Care list</span>
                <div class="ml-auto with-tooltip aftercare-list">
                    <img class="info-img" src="../../../assets/img/info.svg">
                    <span class="tooltiptext">Add a After Care Sessions list to  your website by simply copying and pasting the code</span>
                </div>
            </div>
            <div>
                <button class="secondary-btn btn-center"
                        type="button"
                        @click="copyActivityListWidget('aftercare')">
                    Copy code
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { SchoolSettingsService } from '../../../common/services/settings/school-settings.service';
    import { mapGetters, mapActions } from 'vuex';
    import { saveToClipboard } from '../../../common/utils/clipboard';

    const TWITTER_POST_URL = 'https://twitter.com/intent/tweet?button_hashtag=popsicle&ref_src=twsrc%5Etfw';

    export default {
        name: 'Integrations',
        data() {
            return {
                form: {
                    parentPortalUrl: '',
                    schoolName: '',
                    tagLine: '',
                    portalName: ''
                },
            }
        },
        computed: {
            ...mapGetters(['schoolId']),
            twitterPostUrl() {
                return TWITTER_POST_URL +
                    `&text=Registration open for school ${this.form.schoolName}.` + '&url=' + this.form.parentPortalUrl + '.';
            }
        },
        methods: {
            ...mapActions(['createSuccessNotification']),
            postToFacebook() {
                window.FB.ui({
                    method: 'share',
                    href: this.form.parentPortalUrl,
                    hashtag: '#Popsicle',
                    quote: `Registration open for school ${this.form.schoolName}.`
                }, () => {
                });
            },
            getSchoolsParentPortalInfo() {
                SchoolSettingsService.getSchoolsParentPortalInfo(this.schoolId)
                    .then(({ data }) => {
                        this.form = data;
                    })
            },
            copyRegistrationButtonWidget() {
                const { parentPortalUrl: url, schoolName } = this.form;
                const widgetCode = `<a href="${url}" id="popsicle-registration-widget"> <style>@import url('https://fonts.googleapis.com/css?family=Asap:500&display=swap'); #popsicle-registration-widget{display: flex; align-items: center; color: #19181c; cursor: pointer; font-family: Asap; font-size: 16px; font-weight: 500; max-width: 217px; width: auto; height: 50px; padding: 0 10px; border-radius: 24.5px; background-color: #fee040; border: none; outline: none; text-decoration: none;}#popsicle-registration-widget:hover{background-color: #fff300;}#popsicle-registration-widget span{text-overflow: ellipsis; white-space: nowrap; overflow: hidden;}</style> <span>Register to ${schoolName}</span></a>`;
                saveToClipboard(widgetCode);
                this.createSuccessNotification('You have copied calendar registration button code');
            },
            copyCalendarWidget(activityType) {
                const url = window.location.origin + `/schools/public/${activityType === 'aftercare' ? 'after-care' : activityType}/calendar?schoolId=${this.schoolId}`;
                const widgetCode = `<iframe src="${url}" width="800px" height="822px" style="border-style: ridge; border-width: 1px"></iframe>`;
                saveToClipboard(widgetCode);
                this.createSuccessNotification(`You have copied ${activityType === 'aftercare' ? 'after care sessions' : activityType} calendar widget code`);
            },
            copyActivityListWidget(activityType) {
                const { portalName: slug } = this.form;
                const url = window.location.origin + `/parents/${slug}/public/${activityType === 'aftercare' ? 'after-care' : activityType}`;
                const widgetCode = `<iframe src="${url}" width="1000px" height="822px" style="border-style: ridge; border-width: 1px; padding-left: 10px"></iframe>`;
                saveToClipboard(widgetCode);
                this.createSuccessNotification(`You have copied ${activityType === 'aftercare' ? 'after care sessions' : activityType} list widget code`);
            }
        },
        created() {
            this.getSchoolsParentPortalInfo();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../assets/colors";

    .settings-page {
        padding: 70px 100px 80px 100px;
        @media screen and (max-width: 1200px) {
            padding: 50px 70px 60px 70px;
        }
        @media screen and (max-width: 991px) {
            padding: 50px 50px 60px 50px;
        }
        @media screen and (max-width: 767px) {
            padding: 30px 6% 40px;
        }

        h2 {
            display: flex;
            align-items: center;
            font-size: 24px;
            font-weight: 600;
            line-height: 0.88;
            color: $Dark;
            font-size: 24px;
            margin-bottom: 38px;

            &:not(:first-child) {
                margin-top: 58px;
                @media screen and (max-width: 767px) {
                    margin-top: 48px;
                }
                @media screen and (max-width: 480px) {
                    margin-top: 40px;
                }
            }
        }

        .info-img {
            margin-left: 9px;
            width: 18px;
            height: 18px;
            opacity: 0.15;
        }

        .f-width {
            width: 150px;
        }

        .integration-row {
            display: flex;
            justify-content: space-between;
            align-items: center;

            &:not(:last-child) {
                margin-bottom: 40px;
                @media screen and (max-width: 991px) {
                    margin-bottom: 35px;
                }
                @media screen and (max-width: 767px) {
                    margin-bottom: 30px;
                }
                @media screen and (max-width: 480px) {
                    margin-bottom: 25px;
                }
            }

            > div {
                display: flex;
                align-items: center;

                > a {
                    text-decoration: none;
                }

                img {
                    width: 20px;
                    height: 20px;
                    margin-right: 10px;
                }

                span {
                    vertical-align: middle;
                    font-size: 17px;
                    line-height: 1.18;
                    color: $Dark;
                }

                button {
                    width: 120px;
                    height: 36px;
                    border-radius: 4px;
                    font-size: 16px;
                    @media screen and (max-width: 480px) {
                        width: 115px;
                        padding: 0;
                    }
                }
            }
        }

        .with-tooltip {
            .tooltiptext {
                @media screen and (max-width: 991px) {
                    right: -230px;
                    left: auto;
                    top: -40px;
                }
                @media screen and (max-width: 767px) {
                    right: -230px;
                    left: auto;
                    top: -40px;
                }
                @media screen and (max-width: 480px) {
                    right: -130px;
                    left: auto;
                    top: -40px;
                }
            }
        }

        .class-calendar,
        .camp-calendar {
            .tooltiptext {
                @media screen and (max-width: 480px) {
                    right: -175px;
                }
            }
        }

        .class-list,
        .camp-list {
            .tooltiptext {
                @media screen and (max-width: 991px) {
                    right: -290px;
                }
                @media screen and (max-width: 767px) {
                    right: -340px;
                }
                @media screen and (max-width: 480px) {
                    right: -215px;
                }
            }
        }

        .aftercare-list {
            .tooltiptext {
                @media screen and (max-width: 480px) {
                    right: -160px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/main/settings/Widgets.vue